import FileUploadSection from '@src/Components/FileUploadSection'
import { EmailIntegration } from './EmailIntegration'
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Button } from '@wove/web-ui'
import { useAuth } from '@src/hooks/useAuth'
import { useState } from 'react'
import RequestAccessModal from '../UploadPage/RequestAccessModal'
import { FileTable } from './FileTable'

export default function DashboardPage() {
  const { customer } = useAuth()
  const [requestAccessOpen, setRequestAccessOpen] = useState(false)
  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">
          Upload, process, and manage your logistics data files.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>Upload Files</CardTitle>
              <CardDescription>Upload your shipping rate data files for processing</CardDescription>
            </CardHeader>
            <CardContent>
              {customer?.rateIngestion?.enabled ? (
                <FileUploadSection />
              ) : (
                <>
                  <div className="container mx-auto py-32">
                    <div className="flex flex-col items-center">
                      <p className="text-center mb-6 text-2xl font-semibold">
                        Rate ingestion is not available for your company at the moment.
                      </p>
                      <Button variant="default" onClick={() => setRequestAccessOpen(true)}>
                        Request Access
                      </Button>
                    </div>
                  </div>
                  <RequestAccessModal
                    onClose={() => setRequestAccessOpen(false)}
                    isOpen={requestAccessOpen}
                  />
                </>
              )}
            </CardContent>
          </Card>
        </div>
        <div className="lg:col-span-1">
          <EmailIntegration />
        </div>
      </div>

      <FileTable />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-3">{/* <RecentActivity /> */}</div>
      </div>
    </div>
  )
}
